const categories = {
  category: "UTRUSTNING",
  subCategories: [
    {
      category: "LJUD",
      subCategories: [
        { category: "Linearray" },
        { category: "Högtalare" },
        { category: "Mixerbord" },
        { category: "Signalhantering" },
        { category: "DJ Utrustning" },
        { category: "Mikrofoner" },
        { category: "Trådlösa system" },
        { category: "Lineboxar" },
        { category: "Ljudstativ" },
        { category: "Ljudverktyg" },
      ],
    },
    {
      category: "LJUS",
      subCategories: [
        { category: "Ljusbord" },
        { category: "DMX distribution" },
        { category: "Moving Heads" },
        { category: "Ramper" },
        { category: "LED" },
        { category: "Batterilampor" },
        { category: "Discoeffekter" },
        { category: "Rökmaskiner" },
        { category: "Övrigt Ljus" },
      ],
    },
    {
      category: "KABEL",
      subCategories: [
        { category: "Elcentraler" },
        { category: "3-Fas kabel" },
        { category: "Strömkabel" },
        { category: "Ljudkabel" },
        { category: "DMX kabel" },
        { category: "Nätverkskabel" },
        { category: "BNC kabel" },
        { category: "Övrig kabel" },
        { category: "Kabelskydd" },      ],
    },
    {
      category: "RIGGING",
      subCategories: [
        { category: "Lyftredskap" },
        { category: "F31 Truss" },
        { category: "F32 Truss" },
        { category: "F34 Truss" },
        { category: "Ground Support" },
        { category: "Specialdelar" },
        { category: "Övrig Rigging" },
      ],
    },
    {
      category: "ÖVRIGT",
      subCategories: [
        { category: "Nätverk" },
        { category: "Kom-radios" },
        { category: "Tyger" },
        { category: "Övrigt" },
      ],
    },
    {
      category: "TILL SALU",
      subCategories: [
        { category: "Begagnat Ljud" },
        { category: "Begagnat Ljus" },
        { category: "Begagnat Övrigt" },
      ],
    },
  ],
};

export const categoryByQualifiedName = {};

function initCategories(category, parents = []) {
  category.parents = parents;
  category.qualifiedName = [...parents, category.category].join(" > ");
  categoryByQualifiedName[category.qualifiedName] = category;
  if (!category.subCategories) return;
  category.subCategories.forEach((subCat) => {
    initCategories(subCat, [...parents, category.category]);
  });
}
initCategories(categories);

export default categories;
